<template>
  <div class="app-at-a-glance-table-row">
    <div class="app-at-a-glance-table-row__main" :class="mainTableClass">
      <div class="app-at-a-glance-table-row__column-one" @click="openRow()">
        {{ rowData.CompanyName }}
      </div>
      <div
        v-if="showForecast"
        class="app-at-a-glance-table-row__column-two"
        @click="openRow()"
      >
        <span :class="`phase-${rowData.Current ? rowData.CurrentPhase : ''}`">
          {{ rowData.Current }}
        </span>
      </div>
      <div
        v-if="showForecast"
        class="app-at-a-glance-table-row__column-three"
        @click="openRow()"
      >
        <span
          :class="`phase-${rowData.ColumnOne ? rowData.ColumnOnePhase : ''}`"
        >
          {{ rowData.ColumnOne }}
        </span>
      </div>
      <div
        v-if="showForecast"
        class="app-at-a-glance-table-row__column-four"
        @click="openRow()"
      >
        <span
          :class="`phase-${rowData.ColumnTwo ? rowData.ColumnTwoPhase : ''}`"
        >
          {{ rowData.ColumnTwo }}
        </span>
      </div>
      <div
        v-if="showForecast"
        class="app-at-a-glance-table-row__column-five"
        @click="openRow()"
      >
        <span
          :class="`phase-${rowData.ColumnThree ? rowData.ColumnThreePhase : ''}`"
        >
          {{ rowData.ColumnThree }}
        </span>
      </div>
      <div v-if="!showForecast" class="app-at-a-glance-table-row__column-six">
        <TrendsReportROCTableChart
          :rowData="rowData"
          :imagespath="appUrl"
          height="33"
          width="68"
          :fromApp="true"
          :isGlobal="rowData.IsGlobal"
        />
      </div>
      <div v-if="!showForecast" class="app-at-a-glance-table-row__column-seven">
        <TrendsReportDTTableChart
          :rowData="rowData"
          :imagespath="appUrl"
          height="33"
          width="68"
          :fromApp="true"
          :isGlobal="rowData.IsGlobal"
        />
      </div>
    </div>
    <div
      class="app-at-a-glance-table-row__highlight"
      :class="highlightRowClass"
    >
      <div
        class="highlight-text"
        v-if="this.hasHighlight"
        v-html="rowData.Highlight"
      />
      <div class="toggle-container" @click="toggle()">
        <div class="toggle-icon" v-if="isFavorite">
          <IconRemoveAAG color="#ffffff" />
        </div>
        <div class="toggle-icon" v-else>
          <IconAddAAG color="#ffffff" />
        </div>
        <div class="toggle-text">
          {{
            isFavorite ? 'REMOVE FROM MY AT-A-GLANCE' : 'ADD TO MY AT-A-GLANCE'
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TrendsReportDTTableChart from '~/components/trendsreport/TrendsReportDTTableChart.vue';
  import TrendsReportROCTableChart from '~/components/trendsreport/TrendsReportROCTableChart.vue';
  import IconAddAAG from '~/components/icon/IconAddAAG.vue';
  import IconRemoveAAG from '~/components/icon/IconRemoveAAG.vue';
  export default {
    name: 'AppAtAGlanceTableIndicatorRow',
    components: {
      TrendsReportDTTableChart,
      TrendsReportROCTableChart,
      IconAddAAG,
      IconRemoveAAG,
    },
    props: {
      rowData: {
        type: Object,
        required: true,
      },
      showForecast: {
        type: Boolean,
        required: true,
      },
      isLastRow: {
        type: Boolean,
        default: false,
      },
      userAags: {
        type: [Array, Object],
        required: true,
      },
      fromDashboard: {
        type: [Boolean, Number],
        default: 0,
      },
      appUrl: {
        type: String,
        required: true,
      },
      isGlobal: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showHighlight: false,
        isFavorite: false,
      };
    },
    mounted() {
      this.isFavorite = this.userAags.find(
        (aag) =>
          aag.DOSCode == this.rowData.DOSCode &&
          aag.IsGlobal == this.rowData.IsGlobal
      );
    },
    computed: {
      hasHighlight() {
        return this.rowData.Highlight && this.rowData.Highlight.length > 0;
      },
      mainTableClass() {
        if (this.isLastRow && !this.showHighlight) {
          return 'last-row';
        }
        return '';
      },
      highlightRowClass() {
        if (this.isLastRow) {
          return this.showHighlight ? 'last-row show' : 'close';
        }
        return this.showHighlight ? 'show' : 'close';
      },
    },
    methods: {
      openRow() {
        this.showHighlight = !this.showHighlight;
      },
      toggle() {
        let body = {
          DOSCode: encodeURIComponent(this.rowData.DOSCode),
          IsGlobal: this.rowData.IsGlobal,
          TREditionID: this.rowData.TREditionID,
          ReportType: encodeURIComponent(this.rowData.ReportType),
        };

        if (!this.isFavorite) {
          this.$emit('add-aag', body);
        } else {
          this.$emit('remove-aag', body);
        }
        // if(!this.fromDashboard) {
        //   this.isFavorite = !this.isFavorite;
        // }
      },
    },
  };
</script>
<style scoped lang="scss">
  .app-at-a-glance-table-row {
    &__main {
      display: flex;
      // flex-wrap: nowrap;
      align-items: stretch;
      width: 100%;
      min-height: 47px;
      border-left: 1px solid var(--itr-tr-grey);
      border-right: 1px solid var(--itr-tr-grey);
      border-bottom: 1px solid var(--itr-tr-grey);
      font-size: 12px;
      font-weight: bold;
      &.last-row {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
    &__highlight {
      width: 100%;
      background: var(--itr-white);
      color: var(--itr-blue);
      font-size: 12px;
      line-height: 1.2;
      height: 0;
      overflow: hidden;
      opacity: 0;
      transition: all 0.25s ease-in-out;
      &.show {
        height: auto;
        opacity: 1;
        border-left: 1px solid var(--itr-tr-grey);
        border-right: 1px solid var(--itr-tr-grey);
        border-bottom: 1px solid var(--itr-tr-grey);
      }
      &.close {
        height: 0;
        padding: 0 16px;
        opacity: 0;
      }
      &.last-row {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      .hightlight-text {
        padding: 6px 16px;
        font-size: 12px;
      }
      .toggle-container {
        height: 46px;
        background-color: var(--itr-green-mid);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 16px;
        &:active {
          background-color: var(--itr-green);
        }
        .toggle-icon {
          color: var(--itr-white);
        }
        .toggle-text {
          color: var(--itr-white);
          font-size: 13px;
          font-weight: bold;
          margin-left: 10px;
        }
      }
    }
    &__column-one {
      width: 48%;
      color: var(--itr-blue);
      padding: 6px 16px;
      line-height: 1;
      display: flex;
      align-items: center;
      box-sizing: border-box;
    }
    &__column-two,
    &__column-three,
    &__column-four,
    &__column-five {
      text-align: center;
      width: 13%;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    &__column-six,
    &__column-seven {
      width: 26%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .phase-A {
      color: var(--itr-white);
      background: var(--itr-tr-blue);
      font-weight: bold;
      font-size: 14px;
      height: calc(100% - 14px);
      width: calc(100% - 6px);
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
    .phase-B {
      color: var(--itr-white);
      background: var(--itr-tr-green);
      font-weight: bold;
      font-size: 14px;
      height: calc(100% - 14px);
      width: calc(100% - 6px);
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
    .phase-C {
      color: var(--itr-white);
      background: var(--itr-tr-orange);
      font-weight: bold;
      font-size: 14px;
      height: calc(100% - 14px);
      width: calc(100% - 6px);
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
    .phase-D {
      color: var(--itr-white);
      background: var(--itr-tr-red);
      font-weight: bold;
      font-size: 14px;
      height: calc(100% - 14px);
      width: calc(100% - 6px);
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
    .highlight-text {
    * {
      font-size: 14px !important;
      color: var(--itr-charcoal) !important;
      background-color: transparent !important;
      font-family: 'Open Sans', sans-serif !important;
    }
  }
  }
</style>
